<template>
  <v-progress-circular
    rotate="270"
    :width="circleLineWidth"
    :color="color"
    :size="circleSize"
    :value="percentage"
  >
    <slot>
      <span :class="slotClasses" :style="slotStyles">{{ percentage }}%</span>
    </slot>
  </v-progress-circular>
</template>

<script>
// A safe function for calculating percentage
const calcPercentage = (value, goal) =>
  Math.floor(!isNaN(value) && !isNaN(goal) && goal !== 0 ? (value / goal) * 100 : 0)

export default {
  name: 'GoalBlokInner',
  props: {
    amount: {
      type: Number,
      default: 0
    },
    goal: {
      type: Number,
      required: true
    },
    currencyConfig: {
      type: Object,
      required: true
    },
    color: {
      type: String,
      default: '#2ad9ff'
    },
    circleSize: {
      type: Number,
      default: 200
    },
    circleLineWidth: {
      type: Number,
      default: 10
    },
    locale: {
      type: String,
      default: null
    },
    slotStyles: {
      type: Object,
      default: () => ({})
    },
    slotClasses: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    percentage: 0
  }),
  computed: {
    computedLocale() {
      return this.locale || this.$i18n.locale
    }
  },
  watch: {
    amount(newAmount) {
      this.percentage = calcPercentage(newAmount, this.goal)
    }
  },
  mounted() {
    this.percentage = calcPercentage(this.amount, this.goal)
  }
}
</script>
